import { Icon } from "../Icon";

export interface PaginationProps { total: number; limit: number; offset: number; onChange: (offset: number) => void }

/** Page numbers to show: first, last, and a window around the current page. */
function pageList(page: number, pages: number): (number | "gap")[] {
  const out: (number | "gap")[] = [];
  for (let p = 1; p <= pages; p++) {
    if (p === 1 || p === pages || Math.abs(p - page) <= 1) out.push(p);
    else if (out[out.length - 1] !== "gap") out.push("gap");
  }
  return out;
}

export function Pagination({ total, limit, offset, onChange }: PaginationProps) {
  if (total === 0) return null;
  const page = Math.floor(offset / limit) + 1;
  const pages = Math.max(1, Math.ceil(total / limit));
  const from = offset + 1;
  const to = Math.min(offset + limit, total);
  return (
    <nav className="pagination" aria-label="Phân trang">
      <span className="muted small tabular">
        {from.toLocaleString("vi-VN")}–{to.toLocaleString("vi-VN")} trong <strong>{total.toLocaleString("vi-VN")}</strong> mục
      </span>
      {pages > 1 && (
        <div className="pagination-pages">
          <button type="button" className="page-btn" disabled={page <= 1} aria-label="Trang trước" onClick={() => onChange(offset - limit)}>
            <Icon name="chevronLeft" size={16} />
          </button>
          {pageList(page, pages).map((p, i) => p === "gap"
            ? <span key={`g${i}`} className="page-gap">…</span>
            : (
              <button key={p} type="button" className="page-btn tabular" aria-current={p === page ? "page" : undefined} onClick={() => onChange((p - 1) * limit)}>
                {p}
              </button>
            ))}
          <button type="button" className="page-btn" disabled={page >= pages} aria-label="Trang sau" onClick={() => onChange(offset + limit)}>
            <Icon name="chevronRight" size={16} />
          </button>
        </div>
      )}
    </nav>
  );
}
